// extracted by mini-css-extract-plugin
module.exports = {"outer":"CBModuleHeadline_outer__1SLUc","inner":"CBModuleHeadline_inner__1UINH"};